import React from 'react';
import { ChevronRight } from 'lucide-react';

const t = {
  en: {
    lines: ['STRONG', 'POWERFUL', 'UNSTOPPABLE'],
    sub: 'BUILD THE BODY YOU DESERVE',
    desc: 'TrueFitness combines science-backed strength training with intelligent progression. 8 weeks. Real results.',
    cta: 'START LIFTING',
  },
  de: {
    lines: ['STARK', 'MÄCHTIG', 'UNAUFHALTSAM'],
    sub: 'BAUE DEN KÖRPER, DEN DU VERDIENST',
    desc: 'TrueFitness kombiniert wissenschaftlich fundiertes Krafttraining mit intelligenter Progression. 8 Wochen. Echte Ergebnisse.',
    cta: 'JETZT DURCHSTARTEN',
  },
};

export default function Hero({ lang }) {
  const tx = t[lang];

  return (
    <section className="relative min-h-screen flex items-center justify-start overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1600&q=80"
          alt="Gym"
          className="w-full h-full object-cover"
          style={{ objectPosition: 'center 30%' }}
        />
        {/* Dark overlay with blue tint */}
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(105deg, rgba(15,17,23,0.92) 0%, rgba(15,17,23,0.75) 50%, rgba(15,17,23,0.45) 100%)',
          }}
        />
        {/* Bottom fade */}
        <div
          className="absolute bottom-0 left-0 right-0 h-40"
          style={{
            background: 'linear-gradient(to top, #0f1117 0%, transparent 100%)',
          }}
        />
      </div>

      {/* Blue accent line */}
      <div
        className="absolute left-0 top-0 bottom-0 w-1"
        style={{ background: 'linear-gradient(to bottom, transparent, #3b82f6, transparent)' }}
      />

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 pt-28 pb-20 w-full">
        <div className="max-w-2xl">
          {/* Stacked headline */}
          <div className="mb-6">
            {tx.lines.map((line, i) => (
              <div key={i} className="overflow-hidden">
                <h1
                  className="font-black uppercase leading-none block"
                  style={{
                    fontSize: 'clamp(3rem, 9vw, 7.5rem)',
                    letterSpacing: '-0.02em',
                    color: i === 0 ? '#3b82f6' : '#ffffff',
                    lineHeight: 1.0,
                    marginBottom: '0.05em',
                  }}
                >
                  {line}
                </h1>
              </div>
            ))}
          </div>

          {/* Sub headline */}
          <p
            className="font-bold uppercase mb-4"
            style={{
              fontSize: 'clamp(0.9rem, 2.5vw, 1.25rem)',
              letterSpacing: '0.18em',
              color: '#06b6d4',
            }}
          >
            {tx.sub}
          </p>

          {/* Description */}
          <p
            className="mb-10 max-w-lg leading-relaxed"
            style={{ color: '#94a3b8', fontSize: '1.05rem' }}
          >
            {tx.desc}
          </p>

          {/* CTA button */}
          <a
            href="/s"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-lg font-black uppercase transition-all duration-200 hover:gap-5 hover:shadow-2xl group"
            style={{
              background: 'linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%)',
              color: '#ffffff',
              letterSpacing: '0.12em',
              fontSize: '0.95rem',
              boxShadow: '0 0 40px rgba(59,130,246,0.4)',
            }}
          >
            {tx.cta}
            <ChevronRight size={20} className="transition-transform group-hover:translate-x-1" />
          </a>
        </div>
      </div>
    </section>
  );
}
